export default __webpack_public_path__ + "static/wolfram-dc5b189814971b25acd92d927c39d115.svg";